export default () => ({
  news: null
})
